<template>
<div class="christmas_2022">
    <SimpleHead />
    <div class="top-banner"><img src="https://media5.imgyb.xyz/media/v1/image/9b44e7d9da447163b75cde9e7630350b.jpeg" alt=""></div>
    <div class="warrp">
        


        <div class="active-game">
            <div class="title-tag"><img src="https://media2.imgyb.xyz/media/v1/image/ae28416c06e2b2342bf56b80b7fc0062.png" alt=""></div>
            <div class="tag-cont">
                <img src="https://media3.imgyb.xyz/media/v1/image/17099a042cfd76ba8f5158f78336032b.png" alt="">
            </div>
            <div class="active-content">
              
                
                <div class="blk-cont">
                    <div class="main">活动主题</div>
                    <div class="desc">以 <span class="shadow">#玩味圣诞#</span> 主题，发帖分享自己的 <span class="shadow">圣诞节大餐</span> 、<span class="shadow">出行游玩计划</span> ，或者晒晒送给家人朋友的 <span class="shadow">圣诞礼物</span> 、漂亮的 <span class="shadow">圣诞装饰</span> …</div>
                    <div class="desc"></div>
                </div>
                <div class="blk-cont">
                    <div class="main">参与方式</div>
                    <div class="desc">方式1：通过本 #玩味圣诞# 专题页面，发布美食视频或图文帖子，即成功参与。</div>
                    <div class="desc">方式2：在约克论坛美食版块发布视频或图文帖子，帖子标题带 #玩味圣诞 # ，即成功参与。</div>
                </div>
                <div class="blk-cont">
                    <div class="main">活动奖励</div>
                    <div class="desc">精选奖，不限量，每人5-20元不等微信红包。</div>
                    <div class="desc">幸运奖，10名，每人获赠中国风灯展+恐龙乐园单人票1张。 </div>
                    <div class="desc">优质奖，10名，每人获赠 168Sushi 1人份晚餐。</div>
                </div>
                
                
                <div class="look-detail"><a href="https://forum.yorkbbs.ca/detail/2f1b8b0b-2eb1-4c9d-916a-b4ffde7cbf80?topic=chat" target="_blank">活动详情 &gt;</a></div>
            </div>
        </div>
        <div class="media-banner"><a target="_blank" href="https://forum.yorkbbs.ca/detail/68da184e-345d-4257-ac32-adb7f9adbe38?topic=yoga"><img src="https://media3.imgyb.xyz/media/v1/image/9d825c006b3a9b958cf45389fdcee94b.png" alt=""></a></div>
        <div class="media-banner"><a target="_blank" href="https://forum.yorkbbs.ca/detail/cdc4f575-ac13-43c6-90bc-fcbcffc36730?topic=chat"><img src="https://media4.imgyb.xyz/media/v1/image/de1a05a2b8ab245036496982a388d877.jpeg" alt=""></a></div>
        <div class="tab">
            <div class="item" :class="{active:type==0}" @click="typeChange(0)">精选</div>
            <div class="item" :class="{active:type==1}" @click="typeChange(1)">点赞最多</div>
            <div class="item" :class="{active:type==2}" @click="typeChange(2)">最新发布 </div>
        </div>
        <!---列表展示-->
        <div class="post-list" v-if="list.length>0">
            <template v-for="(item,index) in list" >
                <YorkbbsInfoflowItem v-if="item.app === 'crm_ad'" :data="item" :key="index"></YorkbbsInfoflowItem>
                <ItemSubject v-else :data="item" :key="item.id" />
            </template>

            
        </div>
        <div class="loading-style" v-if="hasMore && listLoading " ><i class="el-icon-loading"></i> 加载中</div>
    </div>
    <div class="join-play">
        <div class="box">
            <a @click="postLink($event)" :href="'/publish/dining?subject=70b64259-928b-41d7-a184-82484e967b35'|hostBuild('forum')" target="_blank"><div><i class="yk yk-cms_edit"></i></div> 参与话题</a>
            <!-- <a @click="postLink($event)" href="javascript:void(0)"><div><i class="yk yk-cms_edit"></i></div> 参与话题</a> -->
        </div>

    </div>
    <CssFooter></CssFooter> 
    <div style="height:100px" class="white-space"></div>
</div>
</template>
<script>
import SimpleHead from '@/components/widgets/simple-head.vue'
import { isScrollToPageBottom ,inflowAdvConvert} from '@/utils/utils';
import { throttle } from 'throttle-debounce';
import YorkbbsInfoflowItem from '@/components/item-infoflow.vue'
import ItemSubject from './item-subject.vue'
import CssFooter from '@/components/css-footer.vue'
export default {
    name:'Christmas2022',
    components:{SimpleHead,YorkbbsInfoflowItem,ItemSubject,CssFooter},
    data(){
        return {
            type:0,
            params:{   
                "offset": 1,
                "size": 10,
                //"sort": ["property_thumbUpTotal: DESC","property_updatedAt: DESC"],
                "sort":['property_top: DESC','property_commentedAt: DESC'],
                "subject": [
                    "70b64259-928b-41d7-a184-82484e967b35"
                ],
                "options":{"elite":[1]},    
            },
            list:[],
            pageComplete:false,
            hasMore:true,
            listLoading:false,
        }
    },
    created(){
        this.getList();
    },
    mounted() {
        window.addEventListener('scroll', this.pageScroll);

        this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('scroll', this.pageScroll);
        });
    },
    methods:{
        typeChange(index){
            if( this.type == index) return false;
            delete this.params.options;
            if( index == 0 ){
                this.params.sort = ['property_top: DESC','property_commentedAt: DESC'];
                this.params['options'] = {"elite":[1]};
            }
            if( index ==1 ){
                this.params.sort = ['property_thumbUpTotal: DESC'];
            }
            if( index == 2 ){
                this.params.sort = ['property_commentedAt: DESC'];
            }
            this.type = index;
            this.params.offset = 1;
            this.hasMore = true;
            this.list = [];
            this.getList();
  
        },
        async getList(){
            this.listLoading = true;
            let result = await this.$axios.post('/bbs/v1/get/post/list/for/subject',this.params);
            this.pageComplete = true;
            this.listLoading = false;
            if( result.code == 0 ){
          
                if( this.params.offset == 1 ){
                    this.list = [];
                }
                var inflowAdv = inflowAdvConvert(result.data.items, 'topic', '3261');
                this.list = this.list.concat(inflowAdv);
                this.hasMore = this.params.offset < result.data.pageTotal;
            }
        },
        pageScroll: throttle(300, function () {
            if( isScrollToPageBottom() && this.pageComplete && this.hasMore && !this.listLoading ){
                this.params.offset ++;
                this.getList();
            }
             
            /* let banner = this.$refs['banner'].scrollHeight;
            let top = document.documentElement.scrollTop || document.body.scrollTop;
            if( top>banner-100){
                this.showFunc = true;
            }else{
                this.showFunc = false;
            } */
 
            /* const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            const offsetTop = this.$refs.tab.offsetTop;
            this.tabFixed = scrollTop >= offsetTop; */
        }),
        postLink(event){
            console.log(event);
            try{
                
                flutterForumPost.postMessage(JSON.stringify({
                    topicId:'9f6ada73-4a8c-457f-8bd9-b9eca97ee4b0',
                    subject:'70b64259-928b-41d7-a184-82484e967b35',
                    name:'美食天地'
                }))
                event.preventDefault()
                return false;
            }catch(err){
                return true;
            }
            
        }
    }
}
</script>
<style lang="less" scoped>
.christmas_2022{
    background-color: #FEE9C7; 
    padding-top: 40px;
    /deep/.top-head{background-color: rgba(194,43,38);}
    .mrg-top30{margin-top: 30px;}
    .warrp{padding: 0 10px;}
    .active-game{ 
        position: relative;
        //background-image: linear-gradient(45deg,#ff9b82 25%,#ff4609 50%,rgba(255,255,255,.15) 75%,transparent 75%,#ff9b82);
        background-image: linear-gradient(45deg,#ff9b82 25%,#ff4609 25%,#ff4609 50%,#ff9b82 50%,#ff9b82 75%,#ff4609 75%,#ff4609);
        background-size: 40px 40px;
        background-repeat: repeat;
        padding: 5px; margin-top: 45px;
        border-radius: 20px;
        margin-bottom: 20px;
        .title-tag{position: absolute; z-index: 3; left: 0; right: 0; top: 0; transform: translateY(-70%);padding: 0 8%;}
        .tag-cont{
            position: absolute; z-index: 2; left: -0;  right: 0; transform: translateY(-75%);
        }
        .active-content{
            position:relative;
            padding: 25px 15px 40px;  
            background: #fff;
            border-radius: 20px; overflow: hidden;
            
            .blk-cont{
                margin-bottom: 15px;
                .main{
                    font-size: 16px; line-height: 24px; color: #F25029; font-weight: 700; 
                }
                .desc{font-size: 14px; line-height: 22px; color: #000;
                    span{
                        background: linear-gradient(#fff 0%,#fff 50%,#FFE4B1 50%,#FFE4B1 100% );
                    }
                }
            }
            .look-detail{
                position: absolute; right: 30px; bottom: 20px; 
                a{color: #F25029; text-decoration: underline;
                    &:hover{color: #b52705;}
                }
                
            }
        }
    }
    .media-banner{margin-bottom: 15px;}
    .post-list{background: #fff;  border-radius: 20px; padding: 15px; margin-bottom: 30px;
        ::v-deep{
            .infoflow-item{border-bottom: 0; margin-bottom: 10px; padding-left: 46px;}
        }
    }
    .tab{
        display: flex; justify-content: center; align-items: center; margin-bottom: 20px;
        .item{
            user-select: none; cursor: pointer; 
            margin:0 25px;
            font-size: 16px; line-height: 24px; color: #000;
            &.active{font-size: 18px; line-height: 30px; font-weight: 700;}
        }
    }
    .join-play{
        position: fixed; z-index: 10; bottom: 150px;  right: 10px;
        .box{
            display: flex; flex-direction: column; align-items: center; justify-content: center; color: #F25029; font-size: 20px; 
            background: linear-gradient(#fed58e,#ffdf00);

            width:76px; height: 76px; user-select: none; cursor: pointer;
            font-size: 12px; color: #111; text-align: center;
            border-radius: 50%;
            i{font-size: 18px; margin-bottom: 10px;}
            &:hover{
                background: #F25029; color: #fff;
            }
        }
    }
    .loading-style{display: flex; margin-bottom: 20px; color: #999; justify-content: center ; align-items: center; font-size: 12px;
        i{margin-right: 5px;}
    }
    .white-space{display: none;}
}
@media screen and (min-width:830px){
    .christmas_2022{
        min-width:800px;
        background-image: url(https://media3.imgyb.xyz/media/v1/image/7a1c459b0fb111646ffb1befbfe59433.png),url(https://media4.imgyb.xyz/media/v1/image/a9e9385242453e8d2f8b153b2216f922.png);
        background-position:center bottom,center top ;
        background-repeat: no-repeat,no-repeat;
        padding-top: 60px;
        .warrp{
            width:800px; margin:0 auto;
        }
        /deep/.top-head{
            .warrp{max-width: 800px;}
        }
        .top-banner{width:800px; margin:0 auto;}
        .active-game{
            margin-top: 75px; margin-bottom: 30px;
            .title-tag{padding: 0 15%;}
            .active-content{
                padding: 45px 30px 10px;
                .blk-cont{
                   
                    .main{
                        font-size: 16px; line-height: 24px;
                    }
                    .desc{font-size: 16px; line-height: 24px; 
                        
                    }
                }
                .look-detail{bottom: 30px;}
            }
        }
        .media-banner{margin-bottom: 15px;}
        .join-play{
            right: calc(50% - 480px);
            
        }
        .post-list{background: #fff;  border-radius: 20px; padding: 30px; margin-bottom: 30px;
            ::v-deep{
                .infoflow-item{border-bottom: 0; margin-bottom: 10px; padding-left: 46px;}
            }
        }

        .white-space{display: block;}
    }

}


</style>